export default "__VITE_ASSET__BOWwytqW__"